var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"primary","to":{ name: 'marks', params: { classId: 'class', sectionId: 'section' } }}},[_vm._v(" marks ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }